import { useEffect, useState } from 'react';
import { ChatScreen } from './components/chat/ChatScreen';
import { HomeScreen } from './components/chat/HomeScreen';
import { ErrorBoundary } from './components/system/ErrorBoundary';
import { useChatStore } from './store/chat';
import { listarConversas, salvarConversa, type ConversaSalva } from './lib/conversas';

/**
 * Navegação estilo WhatsApp: o app abre DIRETO no chat (nova conversa pronta pra
 * receber a receita). O chevron "voltar" do header leva à Home (lista de conversas
 * anteriores, persistidas em localStorage); o FAB verde começa uma conversa nova.
 * Senha DESATIVADA (2026-07-02): GateSenha preservado em components/ p/ reativação.
 */
export default function App() {
  const [view, setView] = useState<'chat' | 'home'>('chat');
  const [conversas, setConversas] = useState<ConversaSalva[]>(() => listarConversas());

  // Autosave: qualquer conversa com mensagem do usuário fica na Home mesmo se
  // o app for fechado sem tocar em "voltar".
  const messages = useChatStore((s) => s.messages);
  const sessionId = useChatStore((s) => s.sessionId);
  useEffect(() => {
    if (view !== 'chat') return;
    if (!messages.some((m) => m.role === 'user')) return;
    salvarConversa({ id: sessionId, sessionId, messages, updatedAt: Date.now() });
  }, [messages, sessionId, view]);

  function voltarPraHome() {
    setConversas(listarConversas());
    setView('home');
  }

  function abrirConversa(c: ConversaSalva) {
    useChatStore.getState().carregarConversa(c.sessionId, c.messages);
    setView('chat');
  }

  function novaConversa() {
    useChatStore.getState().novaConversa();
    setView('chat');
  }

  return (
    <ErrorBoundary>
      {view === 'home' ? (
        <HomeScreen conversas={conversas} onAbrir={abrirConversa} onNova={novaConversa} />
      ) : (
        <ChatScreen onBack={voltarPraHome} />
      )}
    </ErrorBoundary>
  );
}
